import { TokenSymbol } from 'types'
import { OrderDirection } from '../store/spot/types'

// Use this function to get the fee currency of the spot order history
export function getSpotFeeCurrency(
  direction: OrderDirection,
  chargeQuote: boolean,
  makerFeeRate: number,
  baseCurrency: TokenSymbol,
  quoteCurrency: TokenSymbol,
) {
  if (chargeQuote) {
    return quoteCurrency
  }
  if (makerFeeRate < 0) {
    if (direction === OrderDirection.LONG) {
      return quoteCurrency
    } else {
      return baseCurrency
    }
  } else {
    if (direction === OrderDirection.LONG) {
      return baseCurrency
    } else {
      return quoteCurrency
    }
  }
}
